module.exports = __webpack_public_path__ + "static/media/profundidad.1a12dddd.png";